import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import {Link} from "react-router-dom";
import {_countTotalLogin} from "../../../../services/apis/AdminUserServices";
import MemberDetails from "./MemberDetails";

class TeamMember extends Component {
    state = {
        totalLogin: 0,
        collapse: false
    }

    componentDidMount() {
        this._fetchTotalLogin()
    }

    _toggleCollapse = () => {
        this.setState(prevState => ({
            collapse: !prevState.collapse
        }))
    }

    _fetchTotalLogin = async () => {
        const {member} = this.props
        const {_id} = member

        const {success, data} = await _countTotalLogin(_id)

        if (success) {
            this.setState({
                totalLogin: data
            })
        }
    }

    render() {
        const {member} = this.props
        const {totalLogin, collapse} = this.state
        const {_id, profile, email, role} = member
        const {name} = profile

        return (
            <Fragment>
                <tr className={`team-member member-${_id}`}>
                    <td className="name"><Link to={`/a/users/${_id}`}>{name}</Link></td>
                    <td className="email">({totalLogin}) {email}
                        {/*<span className='extend-arrow' onClick={this._toggleCollapse}>&#x25BC;</span>*/}
                    </td>
                    <td className="role">{role}</td>
                </tr>
                {/*{*/}
                {/*    collapse && <tr>*/}
                {/*        <td><MemberDetails member={member}/></td>*/}
                {/*    </tr>*/}
                {/*}*/}
            </Fragment>
        )
    }
}

TeamMember.propTypes = {
    member: PropTypes.object.isRequired
}

export default TeamMember


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/team/TeamMember.js